var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("video", {
    staticStyle: { "object-fit": "fill" },
    attrs: {
      controls: "",
      autoplay: "",
      "webkit-playsinline": "",
      playsinline: "",
      allowfullscreen: "true",
      webkitallowfullscreen: "true",
      mozallowfullscreen: "true",
      "x5-video-player-type": "h5",
      "x5-video-player-fullscreen": "true",
      muted: "",
      width: "100%",
      height: "100%",
    },
    domProps: { srcObject: _vm.srcObject, muted: true },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }